export const SIDE_NAV_WIDTH = 240;
export const TOP_NAV_HEIGHT = 64;

export const MAX_NUMBER_OF_ADS = 20;
